import React from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select, Checkbox, ListItemText, OutlinedInput } from '@mui/material';

const BasicSelect = ({ label, value, onChange, options, multiple = false, renderValue, useChips = false }) => {
  const cleanLabel = label.replace(/\s+/g, '-').toLowerCase();
  const labelId = `${cleanLabel}-label`;
  const selectId = `${cleanLabel}-select`;

  const defaultRenderValue = (selected) => {
    if (useChips) {
      return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
          {selected.map((val) => {
            const opt = options.find((o) => o.value === val);
            return (
              <Chip key={val} label={opt?.label || val} />
            );
          })}
        </Box>
      );
    } else {
      const selectedLabels = options
        .filter((opt) => selected.includes(opt.value))
        .map((opt) => opt.label);
      return selectedLabels.join(', ');
    }
  };

  return (
    <Box sx={{ minWidth: '13.75rem' }}>
      <FormControl fullWidth>
        <InputLabel id={labelId}>{label}</InputLabel>
        <Select
          labelId={labelId}
          id={selectId}
          multiple={multiple}
          value={value}
          onChange={onChange}
          input={<OutlinedInput label={label} />}
          renderValue={renderValue || defaultRenderValue}
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
          }}
          sx={{ minWidth: '13.75rem', maxWidth: '18rem' }}
          useChips
        >
          {options.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                fontSize: '0.875rem',
                width: 'auto',
                maxWidth:'20rem',
              }}>
              {multiple && <Checkbox checked={value.includes(opt.value)} />}
              <ListItemText primary={opt.label} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default BasicSelect;
